export default {
    infoData: {
        companyNamek: '',
        totalAmt: '',
        apAmt: '',
        paymentMethod: '',
        paymentTerms: '',
        paymentTermsDate: '',
        cashAmt: '',
        amountPaid: '',
        acceptAmt: '',
        siteName: '',
        fineAmt: '',
        fineAfterAmt: '',
        chargeoffArAmt: '',
        currencyCode: '',
        courierNumber: '',
        courierServicesCompany: '',
        totalAmount: '',
        totalAmountText: '',
        chargeoffPreAmt: '',
        preInvoiceAmt: '',
        isApService: '',
        status: '',
        depositAmt: '',
        oilAmount: '',
        transferReceivablesAmount: '',
        apRealAmt: ''
    },
    gatherInfo: {
        companyName: ''

    },
    billInfo: {
        chargeoffPreAmt: '',
        transferReceivablesAmount: '',
        depositAmt: ''
    },
    mailInfo: {

    },
    invoiceItems: [
        {
            prop: 'invoiceCode',
            label: '发票代码',
            type: 'normal'
        },
        {
            prop: 'invoiceSerial',
            label: '发票号码',
            type: 'normal'
        },
        {
            prop: 'invoiceTypeName', // SYS_SC_INVOICE_TYPE
            label: '发票类型',
            type: 'normal'
        },
        {
            prop: 'openInvoiceCompany',
            label: '开票单位',
            type: 'normal'
        },
        {
            prop: 'amt',
            label: '发票金额',
            type: 'normal'
        },
        {
            prop: 'taxRate',
            label: '税率',
            type: 'normal'
        },
        {
            prop: 'tax',
            label: '税额',
            type: 'normal'
        },
        {
            prop: 'fee',
            label: '不含税金额',
            type: 'normal'
        },
        {
            prop: 'openInvoiceDate',
            label: '开票日期',
            type: 'normal',
            status: 'redStyle'
        },
        {
            prop: 'invoiceSourceName',
            label: '来源',
            type: 'normal'
        },
        {
            prop: 'createTime',
            label: '上传时间',
            type: 'normal',
            status: 'redStyle'
        }
    ],
    invoiceLists: [],
    accessoryItems: [
        {
            prop: 'id',
            label: '序号',
            type: 'normal'
        },
        {
            prop: 'substr1',
            label: '文件名称',
            type: 'normal'
        },
        // {
        //     prop: 'invoiceTypeName', // SYS_SC_INVOICE_TYPE
        //     label: '发票类型',
        //     type: 'normal'
        // },
        {
            prop: 'createTime',
            label: '上传时间',
            type: 'normal',
            status: 'redStyle'
        }
    ],
    accessoryList: [],
    taxRateData: [],
    tableDataItems: [
        {
            prop: 'apBillNo',
            label: '账单号',
            type: 'normal'
        },
        {
            prop: 'initialFee',
            label: '不含税金额',
            type: 'normal'
        },
        {
            prop: 'initialTax',
            label: '税金',
            type: 'normal'
        },
        {
            prop: 'initialAmt',
            label: '含税金额',
            type: 'normal',
            status: 'redStyle'
        },
        {
            prop: 'fineAmt',
            label: '票前罚扣款金额',
            type: 'normal',
            status: 'redStyle'
        },
        {
            prop: 'fineAfterAmt',
            label: '票后罚扣款金额',
            type: 'normal',
            status: 'redStyle'
        },
        {
            prop: 'chargeoffPreAmt',
            label: '核销预付款金额',
            type: 'normal',
            status: 'redStyle'
        },
        {
            prop: 'depositAmt',
            label: '转供应商押金',
            type: 'normal',
            status: 'redStyle'
        },
        {
            prop: 'chargeoffArAmt',
            label: '转应收账款金额',
            type: 'normal',
            status: 'redStyle'
        },
        {
            prop: 'oilAmt',
            label: '油品金额',
            type: 'normal',
            status: 'redStyle'
        }
    ],
    contractInfoItems: [
        {
            prop: 'contractCode',
            label: '合同编号',
            type: 'normal'
        },
        {
            prop: 'contractName',
            label: '合同名称',
            type: 'normal'
        },
        {
            prop: 'contractStatus',
            label: '合同状态',
            type: 'normal'
        },
        {
            prop: 'businessTypeSupplier',
            label: '合同业务类型',
            type: 'normal'
        },
        {
            prop: 'creatorName',
            label: '生效日期',
            type: 'normal'
        },
        {
            prop: 'failTime',
            label: '失效日期',
            type: 'normal'
        }
    ],
    networkInfoItems: [
        {
            prop: 'type',
            label: '类型',
            type: 'normal'
        },
        {
            prop: 'supName',
            label: '服务商名称',
            type: 'normal'
        },
        {
            prop: 'engineerCode',
            label: '工程师编号',
            type: 'normal'
        },
        {
            prop: 'engineerName',
            label: '工程师名称',
            type: 'normal'
        },
        {
            prop: 'payableTaxAmount',
            label: '应收含税金额',
            type: 'normal'
        },
        {
            prop: 'penaltyDeductionAmount',
            label: '罚扣款金额',
            type: 'normal'
        },
        {
            prop: 'payTaxAmount',
            label: '实收含税金额',
            type: 'normal'
        },
        {
            prop: 'payStatus',
            label: '状态',
            type: 'normal',
            status: 'redStyle'
        }
    ],
    process: {
        step: [
            { value: '开票进度',
                id: '',
                titleName: '全部上传',
                images: {
                    active: 1,
                    notActive: 2
                },
                carName: '',
                carTimes: ''
            },
            { value: '提交付款',
                id: '',
                titleName: '已提交',
                images: {
                    active: 1,
                    notActive: 2
                },
                carName: '1',
                carTimes: ''
            },
            { value: '发票接收',
                id: '',
                titleName: '全部接收',
                images: {
                    active: 1,
                    notActive: 2
                },
                carName: '1',
                carTimes: ''
            },
            { value: '总部审核',
                id: '',
                titleName: '审核通过',
                images: {
                    active: 1,
                    notActive: 2
                },
                carName: '1',
                carTimes: ''
            },
            { value: '保理移交',
                id: '',
                titleName: '',
                images: {
                    active: 1,
                    notActive: 2
                },
                carName: '1',
                carTimes: '',
                isApService: true
            },
            { value: '保理贴现',
                id: '',
                titleName: '',
                images: {
                    active: 1,
                    notActive: 2
                },
                carName: '1',
                carTimes: '',
                isApService: true
            },
            { value: '等待账期',
                id: '',
                titleName: '已到账期',
                images: {
                    active: 1,
                    notActive: 2
                },
                carName: '1',
                carTimes: ''
            },
            { value: '收款进度',
                id: '',
                titleName: '全部付款',
                images: {
                    active: 1,
                    notActive: 2
                },
                carName: '1',
                carTimes: ''
            }
        ]
    }
};
